<template>
    <div class="page">
        <ion-grid>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle">
                <ion-col >
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item">Taiff Code <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="tariffCode" @ionInput="onTariffCodeInput" :disabled="isEditing" class="form-input" type="text"></ion-input>
                            </div>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="3">
                            <ion-label class="section-item">Taiff Description <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="tariffDescription" class="form-input" type="text"></ion-input>
                            </div>
                        </ion-col> -->
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">
                                Effective From
                            </ion-label>
                            <div class="date-picker-box margin-top-10 datepicker-web">
                                <datepicker
                                    class="form-vue-picker"
                                    placeholder="DD/MON/YYYY"
                                    inputFormat="dd/MMM/yyyy"
                                    v-model="effectiveFrom"
                                    :typeable="true"
                                ></datepicker>
                                <span class="custom-calendar-icon">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                <datepicker
                                    class= "form-picker"
                                    placeholder= "Select From Date"
                                    inputFormat="MMM dd, yyyy"
                                    v-model= "effectiveFrom"
                                    :typeable= "true"
                                ></datepicker>
                                <span class="input-icon-calendar">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">
                                Effective To
                            </ion-label>
                            <div class="date-picker-box margin-top-10 datepicker-web">
                                <datepicker
                                    class="form-vue-picker"
                                    placeholder="DD/MON/YYYY"
                                    inputFormat="dd/MMM/yyyy"
                                    v-model="effectiveTo"
                                    :typeable="true"
                                ></datepicker>
                                <span class="custom-calendar-icon">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                <datepicker
                                class= "form-picker"
                                placeholder= "Select To Date"
                                inputFormat="MMM dd, yyyy"
                                v-model= "effectiveTo"
                                :typeable= "true"
                                ></datepicker>
                                <span class="input-icon-calendar">
                                <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                        </ion-col>
                    </ion-row>
                    
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item">Time Of Unit <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-select 
                                    v-model="timeOfUnit"
                                    @ionChange="onTimeOfUnitChange"
                                    class="form-select select-mobile"
                                    placeholder="Select Status"
                                    interface="action-sheet">
                                    <ion-select-option
                                        v-for="tou in timeOfUnitOptions"
                                        :key="tou.code"
                                        :value="tou.code"
                                    >
                                        {{ tou.description }}
                                    </ion-select-option>
                                </ion-select>
                                <select
                                    v-model="timeOfUnit"
                                    @change="onTimeOfUnitChange"
                                    class="input-select select-web"
                                    placeholder="Select Status"
                                    >
                                    <option
                                    v-for="tou in timeOfUnitOptions"
                                        :key="tou.code"
                                        :value="tou.code"
                                    >{{ tou.description }}</option>
                                </select>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item">Zero Tariff <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-select 
                                    v-model="zeroTariff"
                                    @ionChange="onTimeOfUnitChange"
                                    class="form-select select-mobile"
                                    placeholder="Select Status"
                                    :disabled="timeOfUnit === 'Y'"
                                    interface="action-sheet">
                                    <ion-select-option
                                        v-for="val in zeroTariffOption"
                                        :key="val.code"
                                        :value="val.code"
                                    >
                                        {{ val.description }}
                                    </ion-select-option>
                                </ion-select>
                                <select
                                    class="input-select select-web"
                                    v-model="zeroTariff"
                                    @change="onTimeOfUnitChange"
                                    :disabled="timeOfUnit === 'Y'"
                                    placeholder="Select Status"
                                    >
                                    <option
                                    v-for="val in zeroTariffOption"
                                        :key="val.code"
                                        :value="val.code"
                                    >{{ val.description }}</option>
                                </select>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item">Status <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-select 
                                    :value="status"
                                    class="form-select select-mobile"
                                    placeholder="Select Status"
                                    interface="action-sheet">
                                    <ion-select-option
                                        v-for="(item, index) in statusOptions"
                                        :key="index"
                                        :value="item.code"
                                    >
                                        {{ item.description }}
                                    </ion-select-option>
                                </ion-select>
                                <select
                                    class="input-select select-web"
                                    v-model="status"
                                    placeholder="Select Status"
                                    >
                                    <option
                                    v-for="(item, index) in statusOptions"
                                        :key="index"
                                        :value="item.code"
                                    >{{ item.description }}</option>
                                </select>
                            </div>
                        </ion-col>
                       
                    </ion-row>
                    <br>
                    <hr />
                    <br>
                    <div  v-if="displayInd">
                        <div v-for="(unit, index) in tariffDetails" :key="index">
                            <ion-row align-items-stretch>
                                <ion-col size="12" size-md="3">
                                    <ion-label class="section-item">Tariff Rate <span class="required">*</span></ion-label>
                                    <div class="border-line-34 margin-top-10">
                                        <ion-input v-model="unit.rate" :disabled="zeroTariff === 'Y'" id = "rate" class="form-input" type="number"></ion-input>
                                    </div>
                                </ion-col>
                                
                                <ion-col size="12" size-md="3">
                                    <ion-label class="section-item">Time Of Day <span class="required">*</span></ion-label>
                                    <div class="border-line-34 margin-top-10">
                                        <ion-select 
                                            v-model="unit.timeOfDay.code"
                                            :disabled="zeroTariff === 'Y' || timeOfUnit === 'N'"
                                            class="form-select select-mobile"
                                            placeholder="Select Status"
                                            interface="action-sheet">
                                            <ion-select-option
                                                v-for="opt in timeOfDayOptions"
                                                :key="opt.code"
                                                :value="opt.code"
                                                :disabled="timeOfUnit === 'Y' && opt.code === 'ALL_DAY'"
                                            >
                                                {{ opt.description }}
                                            </ion-select-option>
                                        </ion-select>
                                        <select
                                            class="input-select select-web"
                                            v-model="unit.timeOfDay.code"
                                            :disabled="zeroTariff === 'Y' || timeOfUnit === 'N'"
                                            placeholder="Select Status"
                                            >
                                            <option
                                            v-for="opt in timeOfDayOptions"
                                                :key="opt.code"
                                                :value="opt.code"
                                                :disabled="timeOfUnit === 'Y' && opt.code === 'ALL_DAY'"
                                            >{{ opt.description }}</option>
                                        </select>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="3">
                                    <ion-label class="section-item">GST <span class="required">*</span></ion-label>
                                    <div class="border-line-34 margin-top-10">
                                        <ion-input v-model="unit.taxPercentage" id="taxPercentage" :disabled="zeroTariff === 'Y'" @ionInput="onGSTChange(unit)" class="form-input" type="number"></ion-input>
                                    </div>
                                </ion-col>
                                <!-- <ion-col size="12" size-md="3">
                                    <ion-label class="section-item">Desciption <span class="required">*</span></ion-label>
                                    <div class="border-line-34 margin-top-10">
                                        <ion-input v-model="unit.description" class="form-input" type="text"></ion-input>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="3">
                                    <ion-label class="section-item" position="stacked">
                                        Effective From
                                    </ion-label>
                                    <div class="date-picker-box margin-top-10 datepicker-web">
                                        <datepicker
                                            class="form-vue-picker"
                                            placeholder="DD/MON/YYYY"
                                            inputFormat="dd/MMM/yyyy"
                                            v-model="unit.detailEffectiveFrom"
                                            :typeable="true"
                                        ></datepicker>
                                        <span class="custom-calendar-icon">
                                            <img src="/../assets/images/common/datepicker/calendar.png" />
                                        </span>
                                    </div>
                                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                                        <datepicker
                                            class= "form-picker"
                                            placeholder= "Select From Date"
                                            inputFormat="MMM dd, yyyy"
                                            v-model= "unit.detailEffectiveFrom"
                                            :typeable= "true"
                                        ></datepicker>
                                        <span class="input-icon-calendar">
                                            <img src="/../assets/images/common/datepicker/calendar.png" />
                                        </span>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="3">
                                    <ion-label class="section-item" position="stacked">
                                        Effective To
                                    </ion-label>
                                    <div class="date-picker-box margin-top-10 datepicker-web">
                                        <datepicker
                                            class="form-vue-picker"
                                            placeholder="DD/MON/YYYY"
                                            inputFormat="dd/MMM/yyyy"
                                            v-model="unit.detailEffectiveTo"
                                            :typeable="true"
                                        ></datepicker>
                                        <span class="custom-calendar-icon">
                                            <img src="/../assets/images/common/datepicker/calendar.png" />
                                        </span>
                                    </div>
                                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                                        <datepicker
                                        class= "form-picker"
                                        placeholder= "Select To Date"
                                        inputFormat="MMM dd, yyyy"
                                        v-model= "unit.detailEffectiveTo"
                                        :typeable= "true"
                                        ></datepicker>
                                        <span class="input-icon-calendar">
                                        <img src="/../assets/images/common/datepicker/calendar.png" />
                                        </span>
                                    </div>
                                </ion-col> -->
                                </ion-row>
                                <div v-for="(time, tIndex) in unit.timeDetails" :key="tIndex">
                                    <ion-row>
                                        <ion-col size="12" size-md="1.5">
                                            <ion-label class="section-item">From Time <span class="required">*</span></ion-label>
                                            <div class="date-picker-box margin-top-10 datepicker-web">
                                                <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="time.fromTime" :disabled="zeroTariff === 'Y'"  time-picker placeholder="Select Time" />
                                                <span class="custom-calendar-icon time-icon">
                                                    <ion-icon :icon="timeOutline"></ion-icon>
                                                </span>
                                            </div>
                                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                                <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="time.fromTime" :disabled="zeroTariff === 'Y'"  time-picker placeholder="Select Time" />
                                                <span class="input-icon-calendar time-icon">
                                                <ion-icon :icon="timeOutline"></ion-icon>
                                                </span>
                                            </div>
                                        </ion-col>
                                        <ion-col size="12" size-md="1.5">
                                            <ion-label class="section-item">To Time <span class="required">*</span></ion-label>
                                            <div class="date-picker-box margin-top-10 datepicker-web">
                                                <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="time.toTime" :disabled="zeroTariff === 'Y'"  time-picker placeholder="Select Time" />
                                                <span class="custom-calendar-icon time-icon">
                                                    <ion-icon :icon="timeOutline"></ion-icon>
                                                </span>
                                            </div>
                                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                                <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="time.toTime" :disabled="zeroTariff === 'Y'"  time-picker placeholder="Select Time" />
                                                <span class="input-icon-calendar time-icon">
                                                    <ion-icon :icon="timeOutline"></ion-icon>
                                                </span>
                                            </div>
                                        </ion-col>
                                        <ion-col size="12" size-md="2">
                                    <ion-label class="section-item" position="stacked">
                                        Effective From
                                    </ion-label>
                                    <div class="date-picker-box margin-top-10 datepicker-web">
                                        <datepicker
                                            class="form-vue-picker"
                                            placeholder="DD/MON/YYYY"
                                            inputFormat="dd/MMM/yyyy"
                                            v-model="time.effectiveFrom"
                                            :disabled="zeroTariff === 'Y'"
                                            :typeable="true"
                                        ></datepicker>
                                        <span class="custom-calendar-icon">
                                            <img src="/../assets/images/common/datepicker/calendar.png" />
                                        </span>
                                    </div>
                                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                                        <datepicker
                                            class= "form-picker"
                                            placeholder= "Select From Date"
                                            inputFormat="MMM dd, yyyy"
                                            v-model= "time.effectiveFrom"
                                            :disabled="zeroTariff === 'Y'"
                                            :typeable= "true"
                                        ></datepicker>
                                        <span class="input-icon-calendar">
                                            <img src="/../assets/images/common/datepicker/calendar.png" />
                                        </span>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="2">
                                    <ion-label class="section-item" position="stacked">
                                        Effective To
                                    </ion-label>
                                    <div class="date-picker-box margin-top-10 datepicker-web">
                                        <datepicker
                                            class="form-vue-picker"
                                            placeholder="DD/MON/YYYY"
                                            inputFormat="dd/MMM/yyyy"
                                            v-model="time.effectiveTo"
                                            :disabled="zeroTariff === 'Y'"
                                            :typeable="true"
                                        ></datepicker>
                                        <span class="custom-calendar-icon">
                                            <img src="/../assets/images/common/datepicker/calendar.png" />
                                        </span>
                                    </div>
                                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                                        <datepicker
                                        class= "form-picker"
                                        placeholder= "Select To Date"
                                        inputFormat="MMM dd, yyyy"
                                        v-model= "time.effectiveTo"
                                        :disabled="zeroTariff === 'Y'"
                                        :typeable= "true"
                                        ></datepicker>
                                        <span class="input-icon-calendar">
                                        <img src="/../assets/images/common/datepicker/calendar.png" />
                                        </span>
                                    </div>
                                </ion-col>
                                <ion-col v-if="timeOfUnit === 'Y'"  size="12" size-md="2">
                                    <br>
                                    <ion-row  class="fab-group">
                                        <ion-col size="auto">
                                            <ion-fab-button  class="fab-delete fab-btn" v-if="tIndex !== 0" @click="deleteNewTime(index, tIndex)">
                                                <ion-icon :icon="trash"></ion-icon>
                                            </ion-fab-button>
                                        </ion-col>
                                        <ion-col size="auto">
                                            <ion-fab-button class="fab-primary fab-btn" @click="addNewTime(index)">
                                                <ion-icon :icon="add"></ion-icon>
                                            </ion-fab-button>
                                        </ion-col>
                                    </ion-row>
                                </ion-col>
                            </ion-row>
                        </div>
                                
                            <ion-row align-items-stretch>
                                <!-- <ion-col size="12" size-md="3">
                                    <ion-label class="section-item">CGST <span class="required">*</span></ion-label>
                                    <div class="border-line-34 margin-top-10">
                                        <ion-input v-model="unit.cgst" class="form-input" type="text"></ion-input>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="3">
                                    <ion-label class="section-item">SGST <span class="required">*</span></ion-label>
                                    <div class="border-line-34 margin-top-10">
                                        <ion-input v-model="unit.sgst" class="form-input" type="text"></ion-input>
                                    </div>
                                </ion-col> -->
                                <ion-col v-if="this.isEditing || timeOfUnit === 'Y'" size="12" class="ion-text-right">
                                    <ion-button class="btn-primary" color="danger" v-if="index !== 0" @click="deleteTariffRow(index)">Delete</ion-button>
                                    <ion-button class="btn-primary" color="secondary" @click="addNewTariffRow()"><ion-icon :icon="add"></ion-icon> Add New Tariff</ion-button>
                                </ion-col>
                            </ion-row>
                            <br>
                            <hr class="line-style"/>
                            <br>
                        </div>
                    </div>
                </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
                <ion-col size="12" class="col-nopadding ion-text-right">
                    <ion-button class="btn-cancel btn-primary" @click="cancel">Cancel</ion-button>
                    <ion-button class="btn-primary" @click="saveTariff">{{ isEditing ? "Update" : "Add Tariff" }}</ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
   </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonButton, IonCol, IonGrid, IonLabel, IonRow, IonInput, IonSelect, IonSelectOption, IonFabButton, IonIcon } from "@ionic/vue";
import datepicker from 'vue3-datepicker';
import moment from "moment";
import VueDatePicker from '@vuepic/vue-datepicker';
import { ToastUtils } from "../../util/toast-utils";
import { AdminService } from "@/service/admin/admin.service";
import { migratedTryParseServiceError } from "../../service";
import { add, trash, timeOutline, code } from 'ionicons/icons';

export default defineComponent({
    name: 'AddNewTariff',
    components:{
        IonGrid, IonRow, IonCol, IonButton, IonLabel, IonInput, datepicker, IonSelect, IonSelectOption, IonFabButton, VueDatePicker, IonIcon
    },
    data(){
        return{

            displayInd: false,
            add, 
            trash,
            timeOutline,
            tariffCode: "",
            tariffDescription: "",
            effectiveFrom: new Date(),
            effectiveTo: new Date('9999-12-31'),
            detailEffectiveFrom: new Date(),
            detailEffectiveTo: new Date('9999-12-31'),
            timeOfUnit: "",
            zeroTariff: "N",
            tax: "",
            cgst: "",
            sgst: "",
            timeOfDay: "",
            description: '',
            fromTime: "",
            toTime: "",
            rate: "",
            tariff: '',
            tariffDetails: [
                {
                    rate: "",
                    timeOfDay: {"code": "","description" : ""},
                    description: "",
                    taxPercentage: "",
                    timeDetails: [
                        { 
                            fromTime: "", 
                            toTime: "" ,
                            effectiveFrom: new Date(),
                            effectiveTo: new Date('9999-12-31'),
                        }
                    ]
                }
                ],
            timeOfUnitOptions: [],
            zeroTariffOption: [],
            timeOfDayOptions: [],
            isEditing : false,
            tariffdetId: "",
            status: "A",
            "statusOptions": [
                {
                "description": "Active",
                "code": "A"
                },
                {
                "description": "Inactive",
                "code": "I"
                }
            ],
        }
    },
    beforeRouteLeave(to, from, next) {
        localStorage.removeItem('tariffList');
        next();
    },
    async mounted() {
        this.timeOfUnitOptions = await new AdminService().getTimeOfUnitOptions();
        this.zeroTariffOption = await new AdminService().getZeroTariffOption();
        this.timeOfDayOptions = await new AdminService().getTimeOfDayOptions();
        this.tariff = JSON.parse(localStorage.getItem('tariffList'));
        this.displayInd = true;
        if (this.tariff) {
            this.tariffCode = this.tariff.tariffCode;
            this.tariffDescription = this.tariff.description;
            this.effectiveFrom = this.tariff.effectiveFrom ? new Date(this.tariff.effectiveFrom): null;
            this.effectiveTo = this.tariff.effectiveTo ? new Date(this.tariff.effectiveTo) : null;
            this.timeOfUnit = this.tariff.isToUTariff.code;
            this.zeroTariff = this.tariff.zeroTariff.code;
            this.tariffDetails = this.tariff.tariffDetails;
            this.status = this.tariff.status.code;
          
            for(let i = 0; i< this.tariffDetails.length; i++) {
                let tariffDet =this.tariff.tariffDetails[i].timeDetails
                for(let j = 0; j < tariffDet.length; j++) {
                    let fullFromTime = (tariffDet[j].fromTime).split(":");
                    let fullToTime = (tariffDet[j].toTime).split(":");
                    let fTime = {
                        "hours" : fullFromTime[0],
                        "minutes" : fullFromTime[1]
                    }
                    let tTime = {
                        "hours" : fullToTime[0],
                        "minutes" : fullToTime[1]
                    }
                    this.tariffDetails[i].timeDetails[j]["fromTime"] = fTime;
                    this.tariffDetails[i].timeDetails[j]["toTime"] = tTime;
                    this.tariffDetails[i].timeDetails[j]["effectiveFrom"] = new Date(tariffDet[j].effectiveFrom)
                    this.tariffDetails[i].timeDetails[j]["effectiveTo"] = new Date(tariffDet[j].effectiveTo)
                    this.tariffDetails[i].timeDetails[j]["tariffDetId"] = tariffDet[j].tariffdetId
                }
            }

            this.isEditing = true;
        }
        if(!this.isEditing) {
            this.displayInd = true;
        }
    },
    methods: {
        onTariffCodeInput(event) {
            const value = event.target.value.toUpperCase();
            this.tariffCode = value;
            this.tariffDescription = value;
        },
        onGSTChange(unit) {
            const tax = parseFloat(unit.taxPercentage);
            if (!isNaN(tax)) {
                unit.CGSTPercentage = (tax / 2).toFixed(2);
                unit.SGSTPercentage = (tax / 2).toFixed(2);
            } else {
                unit.CGSTPercentage = "";
                unit.SGSTPercentage = "";
            }
        },
        onTimeOfUnitChange() {
            this.tariffDetails.forEach(t => {
                if (this.timeOfUnit === 'N') {
                    t.timeOfDay.code = 'ALL_DAY';
                    t.timeDetails = t.timeDetails.map(td => ({
                        fromTime: {
                            "hours" : "00",
                            "minutes": "00"
                        },   
                        toTime: {
                            "hours" : "23",
                            "minutes": "59"
                        },
                        effectiveFrom: new Date(),
                        effectiveTo: new Date('9999-12-31')   
                    }));

                    if (this.zeroTariff === 'Y') {
                        t.rate = 0;
                        t.taxPercentage = 0;
                    } else {
                        t["rate"] = "";
                        t["rate"] = null;
                        document.getElementById('rate').value = null

                        t["taxPercentage"] = "";
                        t["taxPercentage"] = null;
                        document.getElementById('taxPercentage').value = null
                    }

                    
                } else if (this.timeOfUnit === 'Y') {
                    t.timeOfDay.code = '';
                    t.timeDetails = t.timeDetails.map(td => ({
                        fromTime: null,
                        toTime: null,
                        effectiveFrom: new Date(),
                        effectiveTo: new Date('9999-12-31')
                    }));
                }
            });
        },
        addNewTime(index) {
            this.tariffDetails[index].timeDetails.push({
                fromTime: "",
                toTime: "",
                effectiveFrom: new Date(),
                effectiveTo: new Date('9999-12-31')
            });
        },

        deleteNewTime(index, tIndex) {
            const ranges = this.tariffDetails[index].timeDetails;
            if (ranges.length > 1) {
                ranges.splice(tIndex, 1);
            }
        },
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('YYYY-MM-DD')
            }
        },
        changeDateFormatWithTime(dateValue) {
            return moment(dateValue).format('HH:mm:ss')
        },
        cancel() {
            localStorage.removeItem('tariffList');
            this.$router.back();
        },
        validateTariffDetails(tariffInfo) {
            let isValid = true;

            tariffInfo.forEach((item, index) => {

                if (item.rate === "" || item.rate === null || item.rate === undefined) {
                isValid = false;
                }

                if (item.taxPercentage === "" || item.taxPercentage === null || item.taxPercentage === undefined) {
                isValid = false;
                }

                if (!item.timeDetails || item.timeDetails.length === 0) {
                isValid = false;
                } else {
                    item.timeDetails.forEach((t) => {
                        if (!t.fromTime || !t.toTime) {
                        isValid = false;
                        }
                        if (!t.effectiveFrom  || !t.effectiveTo) {
                            isValid = false;
                        }
                    });
                }
                

            });
            return isValid;
        },
        async saveTariff() {
            if (
                typeof this.tariffCode === "undefined" ||
                this.tariffCode === null ||
                this.tariffCode === "" || 
                (this.tariffCode).toString().trim().length === 0
            ) {
                new ToastUtils().presentToast("Enter Tariff Code");
            }else if( typeof this.tariffDescription === "undefined" ||
                this.tariffDescription === null ||
                this.tariffDescription === "" || 
                this.tariffDescription.trim().length === 0
            ) {
                new ToastUtils().presentToast("Enter Tariff Description");
            }  else if( typeof this.timeOfUnit === "undefined" ||
                this.timeOfUnit === null ||
                this.timeOfUnit === "" || 
                this.timeOfUnit.trim().length === 0
            ) {
                new ToastUtils().presentToast("Select Time Of Unit");
            } else if( typeof this.zeroTariff === "undefined" ||
                this.zeroTariff === null ||
                this.zeroTariff === "" || 
                this.zeroTariff.trim().length === 0
            ) {
                new ToastUtils().presentToast("Select Tariff Type");
            } else if (!this.validateTariffDetails(this.tariffDetails)) {
                new ToastUtils().presentToast("Enter all required params");
            }
              else {
                const payload = {
                    tariffCode: this.tariffCode,
                    description: this.tariffDescription,
                    effectiveFrom: this.effectiveFrom != "" ? this.changeDateFormatWithoutTime(this.effectiveFrom) : "",
                    effectiveTo: this.effectiveTo != "" ? this.changeDateFormatWithoutTime(this.effectiveTo) : "",
                    isToUTariff: this.timeOfUnit,
                    zeroTariff: this.zeroTariff,
                    status: {
                        code: this.status
                    },
                    tariffDetails: this.tariffDetails.map(t => ({
                        
                        tariffCode: this.tariffCode,
                        timeOfDay: t.timeOfDay,
                        season: "ALL",
                        timeDetails: t.timeDetails.map(r => ({
                            fromTime: this.changeDateFormatWithTime(r.fromTime),
                            toTime: this.changeDateFormatWithTime(r.toTime),
                            effectiveFrom: r.effectiveFrom ? this.changeDateFormatWithoutTime(r.effectiveFrom) : "",
                            effectiveTo: r.effectiveTo ? this.changeDateFormatWithoutTime(r.effectiveTo) : "",
                            tariffdetId: r.tariffdetId
                        })),
                        unitOfMeasure: "kWh",
                        rate: t.rate,
                        distributionCost: 0,
                        description: t.description,
                        taxPercentage: t.taxPercentage,
                        CGSTPercentage: t.CGSTPercentage,
                        SGSTPercentage: t.SGSTPercentage
                    }))
                };


                try {
                    
                    let result;

                    if(this.isEditing) {
                        result = await new AdminService().updateTaiff(payload);
                    } else {
                        result = await new AdminService().addNewTariff(payload);
                    }
                    localStorage.removeItem('tariffList');
                    this.$router.push('tariffCreation')

                } catch(error) {
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }
                
                
            }
        },
        deleteTariffRow(index) {
            if (this.tariffDetails.length > 1) {
                this.tariffDetails.splice(index, 1);
            }
        },
        addNewTariffRow() {
            this.tariffDetails.push({
                rate: "",
                timeOfDay: "",
                taxPercentage: "",
                timeDetails: [
                    { 
                        fromTime: "", 
                        toTime: "",
                        effectiveFrom: new Date(),
                        effectiveTo: new Date('9999-12-31'),
                        tariffdetId: null
                    }
                ]
            });
        }
    }
})
</script>

<style scoped>

.fab-group {
  display: flex;
  gap: 0; 
  padding: 5px;
}

.fab-btn {
  width: 20px;
  height: 20px;
  margin-top: 5px;
}

.time-icon {
    color: #21b24b;
}

.line-style {
    border-top: 1px solid #0b1c49 !important;
    margin: 0px;
    opacity: 1;
}
.btn-cancel {
    --background: #8c8b8b 0% 0% no-repeat padding-box;
}
</style>